/* ═══════════════════════════════════════════════════════════════════
   APTUX WAY — Carousel web component
   Used by the hero block to display product images with thumbnails.

   Usage in Liquid:
     <aptux-carousel>
       <div class="aw-carousel-main">
         <img class="aw-carousel-img active" src="...">
         <img class="aw-carousel-img" src="...">
       </div>
       <div class="aw-carousel-thumbs">
         <button class="aw-carousel-thumb active" data-index="0"><img src="..."></button>
         <button class="aw-carousel-thumb" data-index="1"><img src="..."></button>
       </div>
     </aptux-carousel>
   ═══════════════════════════════════════════════════════════════════ */

class AptuxCarousel extends HTMLElement {
  connectedCallback() {
    this.images = this.querySelectorAll('.aw-carousel-img');
    this.thumbs = this.querySelectorAll('.aw-carousel-thumb');
    this.activeIndex = 0;

    this.thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => this.setActive(i));
      thumb.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.setActive((this.activeIndex + 1) % this.thumbs.length);
          this.thumbs[this.activeIndex].focus();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.setActive((this.activeIndex - 1 + this.thumbs.length) % this.thumbs.length);
          this.thumbs[this.activeIndex].focus();
        }
      });
    });
  }

  setActive(i) {
    this.activeIndex = i;
    this.images.forEach((img, idx) => img.classList.toggle('active', idx === i));
    this.thumbs.forEach((thumb, idx) => {
      thumb.classList.toggle('active', idx === i);
      thumb.setAttribute('aria-current', idx === i ? 'true' : 'false');
    });
  }
}

if (!customElements.get('aptux-carousel')) {
  customElements.define('aptux-carousel', AptuxCarousel);
}
